import React, { Component } from 'react';
import { 
  Card,
  CardHeader,
  CardBody
} from 'reactstrap';

class BusinessTotalCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total: 0
    };
  }

  componentDidMount() {
    this.getTotal();
  }

  componentDidUpdate(prevProps) {
    const { prefecture, business } = this.props;

    if(prefecture !== prevProps.prefecture && prefecture) {
      this.getTotal(); 
    } else if(business !== prevProps.business) {
      this.getTotal(); 
    }
  }

  getTotal() {
    const { prefecture, business } = this.props;

    if(prefecture && business) {
      fetch("/api/unifying_factors/" + business).then((resp) => resp.json())
        .then((respJson) => {
          if(respJson.businesses) {
            respJson.businesses.forEach((prefBusiness) => {
              if(prefBusiness.id == prefecture.id) {
                this.setState({ total: prefBusiness.value }); 
                return false;
              } 
            }); 
          }
        });
    }
  }

  render() {
    const { business, prefecture } = this.props;
    const { total } = this.state;

    return (
      <Card className="mb-3">
        <CardHeader className="bg-primary text-white">
          <h5 className="mt-1">{business}</h5>
        </CardHeader>
        <CardBody>
          There are {total} locations in the {prefecture ? prefecture.attributes.name : null} prefecture. 
        </CardBody>
      </Card>
    ); 
  }
}

export default BusinessTotalCard;
